import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiClock, FiCheckCircle, FiArrowRight } = FiIcons;

const StartScreen = ({ onStart }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-2xl mx-auto text-center bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100"
    >
      <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
        <SafeIcon icon={FiShield} className="text-4xl text-blue-600" />
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
        Auto Insurance Coverage Gap Quiz
      </h1>
      <p className="text-lg text-gray-600 mb-8 max-w-xl mx-auto leading-relaxed">
        Are you underinsured, overpaying, or missing critical protection? Take this 60-second quiz to uncover potential gaps in your auto insurance policy.
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <SafeIcon icon={FiClock} className="text-blue-500" />
          <span>Takes 60 seconds</span>
        </div>
        <div className="hidden sm:block text-gray-300">•</div>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <SafeIcon icon={FiCheckCircle} className="text-blue-500" />
          <span>Personalized Results</span>
        </div>
      </div>
      <button
        onClick={onStart}
        className="w-full sm:w-auto px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-95 shadow-lg shadow-blue-200 flex items-center justify-center gap-2 mx-auto"
      >
        <span>Start the Quiz</span>
        <SafeIcon icon={FiArrowRight} />
      </button>
    </motion.div>
  );
};

export default StartScreen;